module.exports = __webpack_public_path__ + "static/media/33.360704ac.mp3";